<script lang="ts">
	import type { BadgeStyle } from '$lib/components/atoms/badge/types';
	import type { IconName } from '$lib/components/icons/types';
	import type { PoiCardScheme } from '$lib/components/pois/types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';

	interface Props {
		icon?: IconName;
		name: string;
		stars?: number | null;
		scheme: PoiCardScheme;
		titleOnTwoLines?: boolean;
		imgUrl?: string;
		badgeIsSquare?: boolean;
		colorStyles?: BadgeStyle;
	}

	const {
		icon,
		name,
		stars = null,
		scheme,
		titleOnTwoLines = false,
		imgUrl,
		badgeIsSquare = false,
		colorStyles,
	}: Props = $props();

	const infosClasses: Record<PoiCardScheme, string> = {
		hotel: 'text-hotel',
		hotelMichelin: 'text-hotel-michelin',
		restaurant: 'text-restaurant',
		restaurantMichelin: 'text-restaurant-michelin',
		tourism: 'text-tourism',
		parking: 'text-coloredneutral compactrows',
		energy: 'text-coloredneutral compactrows',
		electric: 'text-neutral-strongest compactrows',
		rest: 'text-coloredneutral compactrows',
		partner: 'text-coloredneutral compactrows',
	};
	const truncateClasses: Record<PoiCardScheme, string> = {
		hotel: titleOnTwoLines ? '' : 'truncate',
		hotelMichelin: titleOnTwoLines ? '' : 'truncate',
		restaurant: titleOnTwoLines ? '' : 'truncate',
		restaurantMichelin: titleOnTwoLines ? '' : 'truncate',
		tourism: '',
		parking: 'truncate',
		energy: 'truncate',
		electric: 'truncate',
		rest: 'truncate',
		partner: 'truncate',
	};
	const clampLines2Classes: Record<PoiCardScheme, string> = {
		hotel: titleOnTwoLines ? 'clamp-lines-2' : '',
		hotelMichelin: titleOnTwoLines ? 'clamp-lines-2' : '',
		restaurant: titleOnTwoLines ? 'clamp-lines-2' : '',
		restaurantMichelin: titleOnTwoLines ? 'clamp-lines-2' : '',
		tourism: 'clamp-lines-2',
		parking: 'truncate',
		energy: 'truncate',
		electric: 'truncate',
		rest: 'truncate',
		partner: 'truncate',
	};
</script>

<div class="flex items-center">
	<div
		class={['inline-flex justify-between w-full min-w-0 text-body text-4 line-height-6 text-coloredneutral', clampLines2Classes[scheme]]}>
		<div class={truncateClasses[scheme]} data-testid="card-title">{name}</div>

		{#if stars}
			<div class={['flex flex-items-center gap-0.5 text-sm', infosClasses[scheme]]}>
				<RepeatIcons icon="grade" amount={stars} style="grade" />
			</div>
		{/if}
		{#if imgUrl || icon}
			<div class="flex">
				<Badge
					{icon}
					{imgUrl}
					isSquare={badgeIsSquare}
					color={scheme !== 'partner' ? scheme : undefined}
					{colorStyles}
				/>
			</div>
		{/if}
	</div>
</div>
